import { FC, useState } from "react"
import { Catalogs } from "../../pages/SellerCatalogs/sellerCatalogs"
import { FaMinusCircle, FaPlusCircle, FaRegCopy } from "react-icons/fa";
import NoImg from '../../assets/images/no-image.png';
import Swal from "sweetalert2";

type Props = {
  catalog: Catalogs;
}

const SellerCalogsItem: FC<Props> = ({ catalog }) => {
  const [extended, setExtended] = useState(false);

  function copyLink() {
    try {
      const url = window.location.href;
      const host = new URL(url).host;
      const path = new URL(url).pathname.split('/')[1];
      let link = `${host}/${path}/catalog/${window.btoa(catalog.id.toString())}${catalog.linkCatalog}`;
      link = link.replace('&', '?');
      navigator.clipboard.writeText(link).then(() => {
        Swal.fire({
          icon: 'success',
          text: 'Link copiado com sucesso',
          title: 'Link Copiado'
        })
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    } catch (error) {

    }
  }

  return (
    <div className="order-finded">
      <div className="number-order" >
        <div onClick={() => setExtended(!extended)} style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end',

        }}>
          {extended ? (
            <FaMinusCircle color="#636363" />
          ) : (
            <FaPlusCircle color="#636363" />
          )}
          <p><b>Catálogo</b> {catalog.catalog}</p>
        </div>



        <div style={{
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          flex: 'auto'
        }}
          onClick={() => copyLink()}
        >
          <FaRegCopy color="#636363" />
        </div>
      </div>
      {extended && (
        <div className="order-content">
          {catalog.products.map((product) => (
            <>
              <div className="infos" style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                gap:"8px"
              }}>
               
      
                <img src={product.images ? `${product.images.path}/${product.images.imgsuffix}` : NoImg} alt="" style={{
                  width: "75px",
                  height: '75px',
                  borderRadius:'24px',
 
                }} />
        
                <div>
                  <p><b>Produto: </b> {product.name}</p>
                  <p> <b>Código: </b>{product.code}</p>
                </div>
              
              </div>
            </>

          ))

          }
        </div>
      )}
    </div>
  )
}

export { SellerCalogsItem }


